// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarChatHistory_container__qR7jw {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.SideBarChatHistory_main__dkb-a {
    width: 100%;
    height: 100%;
}

.SideBarChatHistory_item__fSrNx {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 6px;
}

.SideBarChatHistory_item__fSrNx:hover {
    background-color: #262626;
}

.SideBarChatHistory_item__fSrNx:active {
    background-color: #404040;
}

.SideBarChatHistory_item_active_edit__-B-TN {
    background-color: #262626;
}

.SideBarChatHistory_item_active__UVvPa,
.SideBarChatHistory_item_active__UVvPa:hover {
    background-color: #404040;
}

.SideBarChatHistory_collapsibleContent__fM\\+1Z {
    overflow: hidden;
    transition: max-height 0.2s ease-in-out;
}

.SideBarChatHistory_item_hide__AAdAg {
    display: none;
}

.SideBarChatHistory_item_collapsed__2iskt {
    max-height: 0;
}

.SideBarChatHistory_item_expanded__8to1x {
    max-height: 3000px;
}

.SideBarChatHistory_expert_butn_box__bDW05 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 40px);
    height: 100%;
    cursor: pointer;
}

.SideBarChatHistory_item_img__yVpq9 {
    width: 14px;
    height: 14px;
}

.SideBarChatHistory_item_title__hFalD,
.SideBarChatHistory_item_text__77CMR {
    width: calc(100% - 30px - 40px);
    color: #e7e7e7;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.SideBarChatHistory_item_title__hFalD {
    font-family: 'PingFangSCRegular', sans-serif;
}

.SideBarChatHistory_item_text_box__tl635 {
    width: calc(100% - 14px - 35px);
    padding: 0 5px;
}

.SideBarChatHistory_item_text__77CMR {
    width: 100%;
}

.SideBarChatHistory_shrink_box__F5Byg {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 40px;
    height: 40px;
}

.SideBarChatHistory_shrink_img__UqOYq {
    width: 11px;
    height: 6px;
}

.SideBarChatHistory_none_history_img__LDuz9 {
    width: 11px;
    height: 3px;
}

.SideBarChatHistory_butn_box__lBNbc {
    width: 35px;
    height: 100%;
}


.SideBarChatHistory_popover_box__VlwZr {

}

.SideBarChatHistory_popover_item__R1g8n {
    width: 150px;
    height: 30px;
}

.SideBarChatHistory_popover_item__R1g8n {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.5s;
}

.SideBarChatHistory_popover_item__R1g8n:hover {
    background-color: #dfdfdf;
}

.SideBarChatHistory_popover_item__R1g8n:active {
    background-color: #cdcdcd;
}

.SideBarChatHistory_popover_item_img__JygFH {
    width: 16px;
    height: 16px;
    margin-right: 10px;
}

.SideBarChatHistory_popover_item_edit__E0c9n,
.SideBarChatHistory_popover_item_delete__SVhNz {
    font-size: 14px;
}


.SideBarChatHistory_popover_item_delete__SVhNz{
    color: #E31A1A;
}

.custom_popover_setting .ant-popover-content .ant-popover-inner {
    padding: 5px;
}

.SideBarChatHistory_butns_box__n-M0H {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}

.SideBarChatHistory_butns_more_img__nvpIW {
    width: 12px;
    height: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarChatHistory/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;;AAEA;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n}\n\n.item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-bottom: 5px;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.item:hover {\n    background-color: #262626;\n}\n\n.item:active {\n    background-color: #404040;\n}\n\n.item_active_edit {\n    background-color: #262626;\n}\n\n.item_active,\n.item_active:hover {\n    background-color: #404040;\n}\n\n.collapsibleContent {\n    overflow: hidden;\n    transition: max-height 0.2s ease-in-out;\n}\n\n.item_hide {\n    display: none;\n}\n\n.item_collapsed {\n    max-height: 0;\n}\n\n.item_expanded {\n    max-height: 3000px;\n}\n\n.expert_butn_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: calc(100% - 40px);\n    height: 100%;\n    cursor: pointer;\n}\n\n.item_img {\n    width: 14px;\n    height: 14px;\n}\n\n.item_title,\n.item_text {\n    width: calc(100% - 30px - 40px);\n    color: #e7e7e7;\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.item_title {\n    font-family: 'PingFangSCRegular', sans-serif;\n}\n\n.item_text_box {\n    width: calc(100% - 14px - 35px);\n    padding: 0 5px;\n}\n\n.item_text {\n    width: 100%;\n}\n\n.shrink_box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n}\n\n.shrink_img {\n    width: 11px;\n    height: 6px;\n}\n\n.none_history_img {\n    width: 11px;\n    height: 3px;\n}\n\n.butn_box {\n    width: 35px;\n    height: 100%;\n}\n\n\n.popover_box {\n\n}\n\n.popover_item {\n    width: 150px;\n    height: 30px;\n}\n\n.popover_item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 10px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.5s;\n}\n\n.popover_item:hover {\n    background-color: #dfdfdf;\n}\n\n.popover_item:active {\n    background-color: #cdcdcd;\n}\n\n.popover_item_img {\n    width: 16px;\n    height: 16px;\n    margin-right: 10px;\n}\n\n.popover_item_edit,\n.popover_item_delete {\n    font-size: 14px;\n}\n\n\n.popover_item_delete{\n    color: #E31A1A;\n}\n\n:global(.custom_popover_setting .ant-popover-content .ant-popover-inner) {\n    padding: 5px;\n}\n\n.butns_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.butns_more_img {\n    width: 12px;\n    height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideBarChatHistory_container__qR7jw`,
	"main": `SideBarChatHistory_main__dkb-a`,
	"item": `SideBarChatHistory_item__fSrNx`,
	"item_active_edit": `SideBarChatHistory_item_active_edit__-B-TN`,
	"item_active": `SideBarChatHistory_item_active__UVvPa`,
	"collapsibleContent": `SideBarChatHistory_collapsibleContent__fM+1Z`,
	"item_hide": `SideBarChatHistory_item_hide__AAdAg`,
	"item_collapsed": `SideBarChatHistory_item_collapsed__2iskt`,
	"item_expanded": `SideBarChatHistory_item_expanded__8to1x`,
	"expert_butn_box": `SideBarChatHistory_expert_butn_box__bDW05`,
	"item_img": `SideBarChatHistory_item_img__yVpq9`,
	"item_title": `SideBarChatHistory_item_title__hFalD`,
	"item_text": `SideBarChatHistory_item_text__77CMR`,
	"item_text_box": `SideBarChatHistory_item_text_box__tl635`,
	"shrink_box": `SideBarChatHistory_shrink_box__F5Byg`,
	"shrink_img": `SideBarChatHistory_shrink_img__UqOYq`,
	"none_history_img": `SideBarChatHistory_none_history_img__LDuz9`,
	"butn_box": `SideBarChatHistory_butn_box__lBNbc`,
	"popover_box": `SideBarChatHistory_popover_box__VlwZr`,
	"popover_item": `SideBarChatHistory_popover_item__R1g8n`,
	"popover_item_img": `SideBarChatHistory_popover_item_img__JygFH`,
	"popover_item_edit": `SideBarChatHistory_popover_item_edit__E0c9n`,
	"popover_item_delete": `SideBarChatHistory_popover_item_delete__SVhNz`,
	"butns_box": `SideBarChatHistory_butns_box__n-M0H`,
	"butns_more_img": `SideBarChatHistory_butns_more_img__nvpIW`
};
export default ___CSS_LOADER_EXPORT___;
